import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import {AuthService} from "./auth.service";
import {URL_PORTAL_SERVICOS_API} from "../util/constants";

@Injectable()
export class PermissoesService {

  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) { }

  getPortifolios(): Observable<any> {
    return this.http.get(`${URL_PORTAL_SERVICOS_API}/portfolio/listarPortfolios`);
  }

  getPermissao(idSolicitacao): Observable<any> {
    return this.http.get(`${URL_PORTAL_SERVICOS_API}/solicitacao-download/permissoes/${idSolicitacao}`);
  }

  getSolicitacao(): Observable<any> {
    return this.http.get(`${URL_PORTAL_SERVICOS_API}/solicitacao-download`);
  }

  getValidarSecretaria(cnes): Observable<any> {
    return this.http.get(`${URL_PORTAL_SERVICOS_API}/solicitacao-download/valida-secretaria/cnes/${cnes}`);
  }

  ativarPermissao(permissao): Promise<any> {
    return this.http.post(`${ URL_PORTAL_SERVICOS_API }/solicitacao-download/permissoes/ativar-inativar`, permissao).toPromise();
  }

  postSolicitacao(solicitacao): Promise<any> {
    return this.http.post(`${ URL_PORTAL_SERVICOS_API }/solicitacao-download/portfolio/${solicitacao.idPortfolio}/cnes/${solicitacao.cnes}`, solicitacao).toPromise();
  }

  postPermissao(permissao): Promise<any> {
    const tokenBc = this.authService.getLocalTokenBrasilCidadao();
    return this.http.post(`${ URL_PORTAL_SERVICOS_API }/solicitacao-download/permissoes/${permissao.idSolicitacao}/cidadao/${permissao.cpf}`, permissao, {headers: {
      AuthorizationSerpro: `${tokenBc}`
    }}).toPromise();
  }

  deleteSolicitacao(idSolicitacao) {
    const url = `${URL_PORTAL_SERVICOS_API}/solicitacao-download/${idSolicitacao}`;
    return this.http.delete(url).toPromise();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/permissoes.service.ts